import React from 'react'
import { injectIntl } from 'react-intl'
import classnames from 'classnames'
import { withLocation, withNotifications } from 'redux/enhancers'
import DeafultNotificationIcon from 'assets/img/default-notification.svg'
import style from './style.module.scss'

const DiagnosticianSnippet = ({
  data,
  intl: { formatMessage },
  unread,
  notificationId,
  readNotice,
}) => {
  if (!data) return null

  let userIsCertifiedDiagnostician = false

  if (data.certifiedDiagnostician && data.certifiedDiagnostician.value === true) {
    userIsCertifiedDiagnostician = true
  }

  const onReadHandler = () => {
    readNotice(notificationId)
  }

  return (
    <div
      className={classnames(style.snippet, { [style.unread]: unread })}
      onMouseEnter={onReadHandler}
      onKeyPress={onReadHandler}
      role="button"
      tabIndex={0}
    >
      <img src={DeafultNotificationIcon} alt="" />
      <div className={style.info}>
        {userIsCertifiedDiagnostician === true
          ? formatMessage({ id: 'notifications.notification.diagnostician-certificate.granted' })
          : formatMessage({ id: 'notifications.notification.diagnostician-certificate.revoked' })}
      </div>
    </div>
  )
}

export default withLocation(withNotifications(injectIntl(DiagnosticianSnippet)))
